var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEmail(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 19,
    viewBox: "0 0 22 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.9031 1.28003H3.90282C2.52436 1.28003 1.40271 2.40149 1.40271 3.78014V15.4473C1.40271 16.8257 2.52417 17.9474 3.90282 17.9474H18.9026C20.2811 17.9474 21.4027 16.8259 21.4027 15.4473V3.78014C21.4029 2.40149 20.2814 1.28003 18.903 1.28003H18.9031ZM18.5578 2.94664L11.403 10.1015L4.24812 2.94664H18.5578ZM18.9031 16.2806H3.90282C3.44314 16.2806 3.06951 15.9068 3.06951 15.4473V4.12542L10.8139 11.8699C10.9764 12.0327 11.19 12.1141 11.403 12.1141C11.6164 12.1141 11.8297 12.0327 11.9922 11.8699L19.7366 4.12542V15.4473C19.7366 15.9071 19.3628 16.281 18.9033 16.281L18.9031 16.2806Z",
    fill: "#585858",
    stroke: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmail);
export default __webpack_public_path__ + "static/media/email.971ca54c2cca5ef62a083c1009c3780e.svg";
export { ForwardRef as ReactComponent };